import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { filter, switchMap, take } from 'rxjs/operators';
import { LoginService } from '../../login/login.service';
import { toObservable } from '@angular/core/rxjs-interop';

export const tosPendingInterceptor: HttpInterceptorFn = (req, next) => {
  const loginService = inject(LoginService);

  const isConfirmTosRequest = (url: string): boolean => {
    return !!url && url.toLowerCase().includes('/user/confirmtos');
  };

  const shouldDelayRequest = (): boolean => {
    if (!loginService.tosPending()) {
      return false;
    }
    if (!req.headers.has('Authorization')) {
      return false;
    }
    return !isConfirmTosRequest(req.url);
  };

  if (!shouldDelayRequest()) {
    return next(req);
  }

  return toObservable(loginService.tosPending).pipe(
    filter((pending) => !pending),
    take(1),
    switchMap(() => next(req))
  );
};
